import React from 'react';

export default function Members() {
  return <h1>Welcome to the Members Page</h1>;
}
